import React from 'react';
import '../styles/Exhibition.css';

function UpcomingExhibitionList({ events }) {
    const handleClick = (url) => {
        if (url) {
            window.open(url, '_blank', 'noopener,noreferrer');
        }
    };

    return (
        <>
            <h3 className="cv-section">UPCOMING</h3>
            <ul className="cv-list">
                {events.map((event, idx) => (
                    <li 
                        key={idx}
                        className={event.external_url ? 'exhibition-item clickable' : ''}
                        onClick={() => handleClick(event.external_url)}
                        style={{ 
                            cursor: event.external_url ? 'pointer' : 'default',
                        }}
                    >
                        <span className="hover-text-only">
                            {event.date} {event.venue}
                        </span>
                    </li>
                ))}
            </ul>
        </>
    );
}

export default UpcomingExhibitionList;
